export default __webpack_public_path__ + "static/media/library-1.5fee45c5.jpg";